import React, { useEffect, Fragment, useState } from 'react';
import { Space, Button, Row, Col, Upload, Form, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import { dummyRequest, uploadFileV2, getFileName } from 'Features/utility';
import placeholderImg from "Assets/img/product-placeholder.png"
import { useTranslate } from 'Translate';
import dayjs from 'dayjs';

const _ = require('lodash');

export default (props) => {
  const { id, meta, data, addReward, editReward, reloadApi, navigate, mode, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue, getValues } = useForm();
  const [fileId, setFileId] = useState();
  const [fileList, setFileList] = useState([]);
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'name',
      label: t("LoyaltyApp.name"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'date_from',
      label: t("General.valid_from_date"),
      placeholder: t("General.please_select"),
      req: false,
      type: 'date',
      reqmessage: 'Date required',
      twocol: false,
      format: 'YYYY-MM-DD',
      colWidth: '1 0 50%',
      static: !allowedEdit,
    },
    {
      name: 'start_time',
      label: t("General.time"),
      placeholder: t("General.please_select"),
      req: false,
      type: 'time',
      reqmessage: 'Time required',
      twocol: false,
      format: 'HH:mm',
      colWidth: '1 0 50%',
      static: !allowedEdit,
    },
    {
      name: 'date_to',
      label: t("General.valid_to_date"),
      placeholder: t("General.please_select"),
      // req: true,
      type: 'date',
      reqmessage: 'Date required',
      twocol: false,
      format: 'YYYY-MM-DD',
      colWidth: '1 0 50%',
      static: !allowedEdit,
    },
    {
      name: 'end_time',
      label: t("General.time"),
      placeholder: t("General.please_select"),
      // req: true,
      type: 'time',
      reqmessage: 'Time required',
      twocol: false,
      format: 'HH:mm',
      colWidth: '1 0 50%',
      static: !allowedEdit,
    },
    {
      name: 'point',
      label: t("LoyaltyApp.point"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      number: true,
      static: !allowedEdit
    },
  ];

  useEffect(() => {
    if (data && 'id' in data && mode !== 'add') {
      setValue('name', data.name);
      setValue('date_from', data.date_from ? dayjs(data.date_from, "YYYY-MM-DD") : '');
      setValue('date_to', data.date_to ? dayjs(data.date_to, "YYYY-MM-DD") : '');
      setValue('start_time', data.start_time ? dayjs(data.start_time, "HH:mm") : '');
      setValue('end_time', data.end_time ? dayjs(data.end_time, "HH:mm") : '');
      setValue('point', data.point);
      if (data?.image_url) {
        setFileList([{ uid: '-1', name: getFileName(data?.image_url), status: 'done', url: data?.image_url }]);
      }else{
        setFileList([]);
      }
    }
  }, [data]);

  // Update Ad
  const onFinish = async (val) => {
    if(mode === 'add') {
      return onFinishAdd(val);
    }
    props.setLoading(true);

    const payload = {
      ...val,
      date_from: dayjs(val?.date_from).format("YYYY-MM-DD"),
      start_time: dayjs(val?.valid_from_time).format("HH:mm"),
      date_to: dayjs(val?.date_to).format("YYYY-MM-DD"),
      end_time: dayjs(val?.valid_from_time).format("HH:mm"),
      blob_id: fileId,
      reward_id: id
    }

    await editReward(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("LoyaltyApp.rewards_edit_success"));
        setFileId();
        reloadApi();
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  // Add Ad
  const onFinishAdd = async (val) => {
    props.setLoading(true);

    const payload = {
      ...val,
      date_from: dayjs(val?.date_from).format("YYYY-MM-DD"),
      start_time: dayjs(val?.start_time).format("HH:mm"),
      date_to: dayjs(val?.date_to).format("YYYY-MM-DD"),
      end_time: dayjs(val?.end_time).format("HH:mm"),
      blob_id: fileId
    }

    await addReward(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("LoyaltyApp.rewards_add_success"));
        setFileId();
        setTimeout(() => navigate(`/loyalty-app/rewards/${res.data.data}`), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  const handleUpload = async (e) => {
    props.setLoading(true);
    try{
      let file = await uploadFileV2(e.file.originFileObj);
      props.setLoading(false);
      setFileId(file?.id);
      setFileList([{ uid: '-1', name: getFileName(file?.url), status: 'done', url: file?.url }]);
    } catch (error) {
      message.error(`${t("General.error_during_upload")} #{error}`);
      props.setLoading(false);
    }
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 20]}>
        <Col span={24} className="text-center">
          <Upload
            disabled={!allowedEdit}
            listType="picture-card"
            className="avatar-uploader larger"
            showUploadList={false}
            accept="image/*"
            maxCount={1}
            fileList={fileList}
            customRequest={dummyRequest}
            onChange={(e) => handleUpload(e)}
          >
            <Space size={4}>
              {fileList?.length > 0 ? (
                <img
                  src={fileList[0].url}
                  alt="avatar"
                  style={{
                    width: '100%',
                  }}
                />
              ) :
                <div>
                  <img src={placeholderImg} alt="" className='w-100' />
                </div>
              }
            </Space>
          </Upload>
        </Col>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}